<template>
  <div class="container">
    <ApiUnavailable v-if="!store.apiAvailable"/>
    <router-view/>
    <router-view v-if="store.showFooter" name="footer"/>
  </div>
</template>

<script setup>
import ApiUnavailable from '@/components/ApiUnavailable.vue';
import {useGlobalStore} from '@/store/globalStore';

const store = useGlobalStore();
</script>
